import React from 'react';
import styled from 'styled-components';
import loading from 'assets/loading.svg';

const Wrapper = styled.div`
  text-align: center;
  .loading {
    width: 150px;
  }
`;

const Loading = () => {
  return (
    <Wrapper>
      <img src={loading} alt="loading" className="loading" />
      <div className="gana navy">취미유형 분석중...</div>
    </Wrapper>
  );
};

export default Loading;
